/*
 * Panzer HTML5 Audio Player
 * Version: 1.1 (Modified with seekTo functionality)
 * Author: http://codecanyon.net/user/liviu_cerchez
 */

(function($) {
    var deviceAgent = navigator.userAgent.toLowerCase();
    var iOS = deviceAgent.match(/(iphone|ipod|ipad)/);

    var methods = {
        init : function(options) {
            const isPreview = this.data('preview') === 'yes',
                    previewText = this.data('preview-text');

            return this.each(function() {
                var $this = $(this);
                if (!$this.is('audio')) return; // check if we are dealing with an audio HTML tag

                var settings = $.extend({
                    layout       : 'mini', // sets the layout style: mini, big
                    theme        : 'dark', // sets the theme: dark, light, custom
                    expanded     : false,  // wheater to expand the player at layout full width
                    cover        : '',     // album cover
                    pauseothers  : true,   // determines if the player should pause when other panzer player is played
                    showduration : false,  // determines if the player should contain a duration text
                    showvolume   : false,  // determines if the player should contain a duration text
                    showdownload : false,  // determines if the player should contain a download button
                    volume       : 100,    // initial volume of the audio player
                    title        : '',     // set a song title to be displayed below the player
                    rates        : false,   // set an array with the playback rates (speed)
                    preload      : 'metadata'
                }, options);
                if (settings.volume < 0 ) settings.volume = 0;
                if (settings.volume >100 ) settings.volume = 100;
                var $this = $(this), audio = $this.get(0), data = $this.data('panzer');
                if ( ! data ) {
                    var additional_classes = '';
                    if (settings.layout == "big") additional_classes = ' panzer-big';
                    if (settings.theme == "light")
                        additional_classes += ' panzer-light';
                    else if (settings.theme == "dark")
                        additional_classes += ' panzer-dark';
                    else
                        additional_classes += ' panzer-custom';
                    if (settings.rates)
                        additional_classes += ' has-rates';
                    if (settings.expanded) additional_classes += ' panzer-expand';
                    if (settings.pauseothers) additional_classes += ' pause-others';
                    if (!!this.canPlayType) {
                        controls = '<div class="plyr__actions controls">' +
                            '<button type="button" '+(isPreview ? 'disabled' : '' )+' class="plyr__control play play-pause" data-plyr="play">' +
                            `<svg class="icon--pressed" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M16,2a3,3,0,0,0-3,3V19a3,3,0,0,0,6,0V5A3,3,0,0,0,16,2Zm1,17a1,1,0,0,1-2,0V5a1,1,0,0,1,2,0ZM8,2A3,3,0,0,0,5,5V19a3,3,0,0,0,6,0V5A3,3,0,0,0,8,2ZM9,19a1,1,0,0,1-2,0V5A1,1,0,0,1,9,5Z"></path></svg>` +
                            '<svg class="icon--not-pressed" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.54,9,8.88,3.46a3.42,3.42,0,0,0-5.13,3V17.58A3.42,3.42,0,0,0,7.17,21a3.43,3.43,0,0,0,1.71-.46L18.54,15a3.42,3.42,0,0,0,0-5.92Zm-1,4.19L7.88,18.81a1.44,1.44,0,0,1-1.42,0,1.42,1.42,0,0,1-.71-1.23V6.42a1.42,1.42,0,0,1,.71-1.23A1.51,1.51,0,0,1,7.17,5a1.54,1.54,0,0,1,.71.19l9.66,5.58a1.42,1.42,0,0,1,0,2.46Z"></path></svg>' +
                            '</button>';
                        if (settings.rates) {
                            controls += '<div class="rates" style="display: none; position: absolute;" >';
                            controls += '<div class="current-rate" data-rate="' + Object.values(settings.rates).pop() + '">' + Object.keys(settings.rates).pop() + '</div><span class="dropdown-rates">';
                            controls += '</span></div>';
                            let active = '';
                            for (var rate in settings.rates) {
                                active = '';
                                if (settings.rates[rate] === 1) {
                                    active = ' active ';
                                }
                                controls += '<button data-rate="' + settings.rates[rate] + '" type="button" class="plyr__control speed '+active+' plyr__control--slower">'+rate+'</button>';
                                // controls += '<span data-rate="' + settings.rates[rate] + '">' + rate + '</span>';
                            }
                        }
                        controls += '</div>';
                        // controls += '<div class="progress-wrapper"><div class="progress"><div class="elapsed" style="width:0;display:none"></div></div></div>';
                        controls += '<div class="plyr__wrap">';
                        if (isPreview) {
                            controls += '<div class="lock-player">🔒 ' + previewText + '</div>';
                        } else {
                            controls += '<div class="plyr__progress">' +
                                '<input data-plyr="seek" type="range" class="range" min="0" max="100" step="0.01" value="0" aria-label="Seek">' +
                                '<progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress>' +
                                '<span role="tooltip" class="plyr__tooltip">00:00</span>' +
                            '</div>';
                        }

                        if (settings.showduration && !isPreview) {
                            var m, s;
                            m = Math.floor( audio.duration / 60 );
                            m = isNaN( m ) ? '00' : ( m >= 10 ) ? m : '0' + m;
                            s = Math.floor( audio.duration % 60 );
                            s = isNaN( s ) ? '00' : ( s >= 10 ) ? s : '0' + s;
                            if (m>100) {
                                controls += '<div class="plyr__time plyr__time--current duration" aria-label="Current time">'+m+':'+s+'</div>';
                            } else {
                                controls += '<div class="plyr__time plyr__time--current duration" aria-label="Current time">'+m+':'+s+'</div>';
                            }
                            controls += '</div>';
                            additional_classes += ' show-duration';
                        }
                        if (settings.showvolume) {
                            controls += '<div class="volume-wrapper"><span></span><div class="volume"><div class="set" style="width:'+settings.volume+'%"></div></div></div>';
                            additional_classes += ' show-volume';
                        }
                        if (settings.showdownload) {
                            var src = $this.attr('src');
                            if (typeof src === 'undefined') src = $this.children('source:first').attr('src');
                            if (src) {
                                controls += '<div class="download-wrapper"><a class="download" href="'+src+'" title="Download File" download><em></em></a></div>';
                                additional_classes += ' show-download';
                            }
                        }
                    } else {
                        var src = $this.attr('src');
                        if (typeof src === 'undefined') src = $this.children('source:first').attr('src');
                        if (typeof src === 'undefined') {
                            controls = '<strong class="alert">Please specify an audio source file.</strong>';
                            additional_classes += ' panzer-unsupported';
                        }
                        else {
                            controls = '<div class="controls"><a class="download" href="'+src+'" title="Download File" download><em></em></a></div><strong class="alert">Download Audio</strong>';
                            additional_classes += ' panzer-download';
                        }
                    }
                    if (settings.cover != '') {
                        album_cover = '<div class="cover"><img src="'+settings.cover+'" alt="" /></div>';
                    }
                    else {
                        album_cover = '';
                    }
                    if (!settings.title || 0 === settings.title.length) {
                        song_title = ($this.attr('title')) ?  '<div class="title">' + $this.attr('title') + '</div>' : '';
                    }
                    else {
                        song_title = '<div class="title">'+settings.title+'</div>';
                    }
                    $player = $('<div class="plyr plyr--full-ui plyr--audio plyr--html5 plyr--paused panzer' + additional_classes + '">' + album_cover + '<div class="plyr__controls">' + controls + '</div>' + song_title + '</div>').appendTo('.player__content');
                    $this.after($player).data('panzer', {
                        target : $this,
                        audio  : audio,
                        player : $player,
                        loc    : $this.prev()
                    });
                    if (iOS) {
                        $this.css({
                            'position' : 'absolute',
                            'top'      : -9999,
                            'width'    : 0,
                            'height'   : 0,
                            'display'  : 'none',
                            'visibility' : 'hidden',
                            'overflow'   : 'hidden'
                        });
                    } else {
                        $this.detach();
                    }
                    $player.data('panzer', {
                        audio  : audio
                    });
                    if (!!this.canPlayType) {
                        $('.play',$player).on('click',function(e) {
                            if ($(this).hasClass('play')) {
                                $('.panzer.pause-others').each(function(){
                                    var data = $(this).data('panzer');
                                    if ( data && !data.audio.paused ) data.audio.pause();
                                });
                                $('.panzerlist.pause-others').each(function(){
                                    var data = $(this).find('a.active').data('panzerlist');
                                    if ( data && !data.audio.paused ) data.audio.pause();
                                });
                            }
                            data = $(this).parents('.panzer').data('panzer');
                            if ( data.audio.paused ) {
                                data.audio.play();
                            } else {
                                data.audio.pause();
                            }
                        });
                        audio.preload = settings.preload;
                        audio.addEventListener('error', function(e) {
                            console.warn('Audio error:', this.error ? this.error.code : 'unknown');
                            if (this.error && this.error.code === 4) {
                                console.warn('Audio format not supported or server error');
                            }
                        });
                        audio.addEventListener('stalled', function() {
                            console.warn('Audio stalled - server may not support proper streaming');
                            // Force reload from current position
                            var currentTime = this.currentTime;
                            var wasPlaying = !this.paused;
                            setTimeout(() => {
                                if (this.readyState < 3 && this.networkState !== 3) {
                                    console.log('Attempting to recover from stall...');
                                    this.load(); // Reload the audio
                                    this.currentTime = currentTime;
                                    if (wasPlaying) {
                                        this.play().catch(e => console.warn('Could not resume playback:', e));
                                    }
                                }
                            }, 2000);
                        });
                        audio.addEventListener('loadstart', function() {
                            console.log('Audio loading started');
                        });

                        audio.addEventListener('canplaythrough', function() {
                            console.log('Audio can play through without stopping');
                        });

                        audio.addEventListener('suspend', function() {
                            console.warn('Audio loading suspended - server may have stopped streaming');
                        });
                        audio.addEventListener("play", function() {
                            data = $(this).data('panzer');
                            $('.play',data.player).toggleClass('play pause plyr__control--pressed');
                        });
                        audio.addEventListener("pause", function() {
                            data = $(this).data('panzer');
                            clearTimeout(audio.playUntilTimer);
                            $('.pause',data.$player).toggleClass('play pause plyr__control--pressed');
                        });
                        audio.addEventListener("ended", function() {
                            data = $(this).data('panzer');
                            data.audio.pause();
                        });

                        audio.addEventListener("timeupdate", function() {
                            data = $(this).data('panzer');
                            var percent = data.audio.currentTime * 100 / data.audio.duration;
                            if (!isNaN( percent )) {
                                var m, m_str, s;
                                m = Math.floor( data.audio.currentTime / 60 );
                                m_str = isNaN( m ) ? '00' : ( m >= 10 ) ? m : '0' + m;
                                s = Math.floor( data.audio.currentTime % 60 );
                                s = isNaN( s ) ? '00' : ( s >= 10 ) ? s : '0' + s;
                                if ( !isNaN( m ) && m > 99 ) $('.duration',data.player).addClass('small');
                                $('.duration',data.player).html(m_str + ':' + s);
                                if (percent == 0) {
                                    $('.elapsed',data.player).hide().css('width',0);
                                } else {
                                    $('.elapsed',data.player).show().css('width', percent+'%');
                                }

                                $('.range',data.player).val(percent);
                                $('.plyr__tooltip',data.player).text(m_str + ':' + s);
                                var pos = $('.plyr__progress',data.player).width() * percent / 100;
                                var tooltip_width = $('.plyr__tooltip',data.player).width();
                                if (pos < tooltip_width/2) pos = tooltip_width/2;
                                if (pos > $('.plyr__progress',data.player).width() - tooltip_width/2) pos = $('.plyr__progress',data.player).width() - tooltip_width/2;
                                $('.plyr__tooltip',data.player).css('left',pos);
                                // increase style="--value: 10.28%;"
                                $('.range',data.player).css('--value', percent + '%');
                                $('.plyr__progress__buffer',data.player).val(data.audio.buffered.end(data.audio.buffered.length-1) / data.audio.duration * 100);

                                window.playPeriods.forEach(period => {
                                    if (data.audio.currentTime >= period.start && data.audio.currentTime <= period.finish) {
                                        if (window.currentPeriod !== period.sentence) {
                                            $('.word').removeClass('selected');
                                            window.keepPopOverWordsSelected();
                                        }
                                        window.currentPeriod = period.sentence;
                                        $(period.sentence).find('.word').addClass('selected');
                                    }
                                });
                            }
                        });
                        audio.addEventListener('progress', function() {
                            data = $(this).data('panzer');
                            if (this.buffered.length > 0) {
                                var bufferedEnd = this.buffered.end(this.buffered.length - 1);
                                var duration = this.duration;
                                if (duration > 0) {
                                    var bufferedPercent = (bufferedEnd / duration) * 100;
                                    $('.plyr__progress__buffer', data.player).val(bufferedPercent);
                                }
                            }
                        });
                        if (settings.showvolume) {
                            audio.addEventListener("volumechange", function() {
                                data = $(this).data('panzer');
                                var percent = data.audio.volume * 100;
                                if (percent == 0)
                                    $('.volume .set',data.player).hide().css('width',0);
                                else
                                    $('.volume .set',data.player).show().css('width', percent+'%');
                            });
                            audio.volume = settings.volume / 100;
                            var leftButtonDown = false;
                            $('.volume',$player).on("mousedown",function(e){
                                if(e.which === 1) {
                                    leftButtonDown = true;
                                    changeVolume($(this),e);
                                }
                            }).on("mouseup",function(e){
                                if(e.which === 1) leftButtonDown = false;
                            }).on("mousemove",function(e){
                                if (e.which = 1 && leftButtonDown) {
                                    changeVolume($(this),e);
                                }
                            });
                            function changeVolume($this,e) {
                                var offset = $this.offset();
                                var x = e.pageX - offset.left;
                                var percent = 100 * x / ($this.width()+1);
                                if (percent < 0) percent = 0;
                                if (percent > 100) percent = 100;
                                data = $this.parents('.panzer').data('panzer');
                                data.audio.volume = percent / 100;
                            }
                        }
                        $('.range',$player).on("input",function(e){
                            var $this = $(this);
                            var seekto = $this.val();
                            data = $this.parents('.panzer').data('panzer');
                            var targetTime = data.audio.duration / 100 * seekto;

                            // Enhanced seeking for range input
                            var performSeek = function() {
                                data.audio.currentTime = targetTime;

                                // Set up recovery for failed seeks
                                var seekTimeout = setTimeout(function() {
                                    if (Math.abs(data.audio.currentTime - targetTime) > 1) {
                                        console.warn('Range seek may have failed, trying alternative approach');
                                        var src = data.audio.src;
                                        data.audio.src = '';
                                        data.audio.src = src;
                                        data.audio.addEventListener('canplay', function() {
                                            data.audio.currentTime = targetTime;
                                        }, { once: true });
                                    }
                                }, 3000);

                                data.audio.addEventListener('seeked', function() {
                                    clearTimeout(seekTimeout);
                                }, { once: true });
                            };

                            if (data.audio.readyState === 0) {
                                data.audio.addEventListener('canplay', performSeek, { once: true });
                            } else {
                                performSeek();
                            }
                        });
                        $('.progress',$player).on("click",function(e){
                            var offset = $(this).offset();
                            var x = e.pageX - offset.left;
                            var percent = 100 * x / ($(this).width()+1);
                            if (percent < 0) percent = 0;
                            if (percent > 100) percent = 100;
                            data = $(this).parents('.panzer').data('panzer');
                            var time = Math.round(data.audio.duration / 100 * percent);

                            // Better seeking for server streaming issues
                            var seekToPosition = function() {
                                var targetTime = time;

                                // For servers that don't handle range requests well,
                                // we need to be more careful with seeking
                                data.audio.currentTime = targetTime;

                                // Set up a recovery mechanism if seeking fails
                                var seekTimeout = setTimeout(function() {
                                    if (Math.abs(data.audio.currentTime - targetTime) > 1) {
                                        console.warn('Seek may have failed, trying alternative approach');
                                        // Try loading from scratch if seek didn't work
                                        var src = data.audio.src;
                                        data.audio.src = '';
                                        data.audio.src = src;
                                        data.audio.addEventListener('canplay', function() {
                                            data.audio.currentTime = targetTime;
                                        }, { once: true });
                                    }
                                }, 3000);

                                // Clear timeout if seek succeeds
                                data.audio.addEventListener('seeked', function() {
                                    clearTimeout(seekTimeout);
                                }, { once: true });

                                // Force a small pause/play cycle to help with buffering
                                if (!data.audio.paused) {
                                    var wasPlaying = true;
                                    data.audio.pause();
                                    setTimeout(function() {
                                        if (wasPlaying && data.audio.readyState >= 3) {
                                            data.audio.play().catch(e => console.warn('Could not resume after seek:', e));
                                        }
                                    }, 100);
                                }
                            };

                            if ( data.audio.readyState === 0 ) {
                                data.audio.addEventListener('canplay', seekToPosition, { once: true });
                            } else {
                                seekToPosition();
                            }
                        });
                        $('button.plyr__control.speed',$player).on("click",function(e){
                            var $rate = $(this), $rate_drop = $rate.parent(), current = $rate.data("rate");
                            jQuery('.current-rate',$rate_drop.parent()).html($rate.html()).attr("data-rate",current);
                            $rate_drop.addClass("hide-clicked");
                            data = $(this).parents('.panzer').data('panzer');
                            data.audio.playbackRate = parseFloat( current );
                            setTimeout(function(){
                                $rate_drop.removeClass("hide-clicked");
                            }, 50);
                            $('.speed').removeClass('active');
                            $(this).addClass('active')
                        });
                        $('.rates',$player).on("click",function(e){
                            var $target = $(e.target);
                            if ($target.hasClass("rates") || $target.hasClass("current-rate")){
                                $(this).toggleClass("clicked");
                                if(!$(this).hasClass("clicked")){
                                    $(this).addClass("hide-clicked");
                                } else {
                                    $(this).removeClass("hide-clicked");
                                }
                            }
                        });
                    }
                }
            });
        },

        // NEW: seekTo method - seeks to a specific time in seconds
        seekTo : function(time) {
            // If this jQuery collection is empty (element was detached),
            // try to find the player by the original element ID
            if (this.length === 0) {
                // Fallback: apply to all players (if only one exists)
                var $allPlayers = $('.panzer');
                if ($allPlayers.length === 1) {
                    return $allPlayers.panzer('seekTo', time);
                }

                console.warn('seekTo: Could not find audio element or player');
                return this;
            }

            return this.each(function() {
                var $this = $(this), data = $this.data('panzer');

                // If this is the original audio element and it has panzer data, use it
                if (data && data.audio) {
                    // Audio element with direct data
                }
                // If no data, try to find the player wrapper
                else {
                    var $player = $this.next('.panzer');
                    if ($player.length) {
                        data = $player.data('panzer');
                    } else if ($this.hasClass('panzer')) {
                        // Called directly on player wrapper
                        data = $this.data('panzer');
                    } else {
                        // Maybe the audio element was detached, try finding by audio reference
                        $('.panzer').each(function() {
                            var playerData = $(this).data('panzer');
                            if (playerData && playerData.audio === $this.get(0)) {
                                data = playerData;
                                return false; // break the loop
                            }
                        });
                    }
                }

                if (data && data.audio) {
                    // Ensure time is within bounds
                    if (time < 0) time = 0;
                    if (data.audio.duration && time > data.audio.duration) time = data.audio.duration;

                    // Enhanced seeking for problematic servers
                    var performSeek = function() {
                        var targetTime = time;
                        data.audio.currentTime = targetTime;

                        // Set up recovery for failed seeks
                        var seekCheckTimeout = setTimeout(function() {
                            if (Math.abs(data.audio.currentTime - targetTime) > 2) {
                                console.warn('Seek may have failed due to server streaming issues');
                                // Try reloading if seek completely failed
                                var wasPlaying = !data.audio.paused;
                                var src = data.audio.src;
                                data.audio.pause();
                                data.audio.src = '';
                                data.audio.load();
                                data.audio.src = src;
                                data.audio.addEventListener('loadedmetadata', function() {
                                    data.audio.currentTime = targetTime;
                                    if (wasPlaying) {
                                        data.audio.play().catch(e => console.warn('Could not resume playback:', e));
                                    }
                                }, { once: true });
                            }
                        }, 5000);

                        // Clear timeout if seek succeeds
                        data.audio.addEventListener('seeked', function() {
                            clearTimeout(seekCheckTimeout);
                        }, { once: true });
                    };

                    // Check if audio is ready
                    if (data.audio.readyState === 0) {
                        // Audio not ready, wait for it to be playable
                        data.audio.addEventListener('canplay', performSeek, { once: true });
                    } else {
                        performSeek();
                    }
                }
            });
        },

        // NEW: seekToPercent method - seeks to a percentage of the total duration
        seekToPercent : function(percent) {
            return this.each(function() {
                var $this = $(this), data = $this.data('panzer');

                // If this is the original audio element, get data from the player wrapper
                if (!data) {
                    var $player = $this.next('.panzer');
                    if ($player.length) {
                        data = $player.data('panzer');
                    }
                }

                if (data && data.audio) {
                    // Ensure percent is within bounds
                    if (percent < 0) percent = 0;
                    if (percent > 100) percent = 100;

                    // Calculate time based on percentage
                    var time = (data.audio.duration * percent) / 100;

                    // Use seekTo method
                    $this.panzer('seekTo', time);
                }
            });
        },

        // NEW: getCurrentTime method - returns current playback time
        getCurrentTime : function() {
            var $this = $(this), data = $this.data('panzer');

            // If this is the original audio element, get data from the player wrapper
            if (!data) {
                var $player = $this.next('.panzer');
                if ($player.length) {
                    data = $player.data('panzer');
                }
            }

            if (data && data.audio) {
                return data.audio.currentTime;
            }
            return 0;
        },

        // NEW: getDuration method - returns total duration
        getDuration : function() {
            var $this = $(this), data = $this.data('panzer');

            // If this is the original audio element, get data from the player wrapper
            if (!data) {
                var $player = $this.next('.panzer');
                if ($player.length) {
                    data = $player.data('panzer');
                }
            }

            if (data && data.audio) {
                return data.audio.duration || 0;
            }
            return 0;
        },

        // NEW: playUntil method - plays from start time to end time (in seconds)
        playUntil : function(startTime, endTime) {
            if (this.length === 0) {
                var $allPlayers = $('.panzer');
                if ($allPlayers.length === 1) {
                    return $allPlayers.panzer('playUntil', startTime, endTime);
                }
                console.warn('playUntil: Could not find audio element or player');
                return this;
            }

            return this.each(function() {
                var $this = $(this), data = $this.data('panzer');

                // Get data same way as seekTo
                if (!data || !data.audio) {
                    var $player = $this.next('.panzer');
                    if ($player.length) {
                        data = $player.data('panzer');
                    } else if ($this.hasClass('panzer')) {
                        data = $this.data('panzer');
                    } else {
                        $('.panzer').each(function() {
                            var playerData = $(this).data('panzer');
                            if (playerData && playerData.audio === $this.get(0)) {
                                data = playerData;
                                return false;
                            }
                        });
                    }
                }

                if (data && data.audio) {
                    var audio = data.audio;

                    // Validate and set bounds
                    if (startTime < 0) startTime = 0;
                    if (audio.duration && endTime > audio.duration) endTime = audio.duration;
                    if (startTime >= endTime) {
                        console.warn('playUntil: startTime must be less than endTime');
                        return;
                    }

                    // Clear any existing playUntil timer
                    if (audio.playUntilTimer) {
                        clearTimeout(audio.playUntilTimer);
                        audio.removeEventListener('timeupdate', audio.playUntilHandler);
                        audio.removeEventListener('ratechange', audio.playUntilRateHandler);
                        delete audio.playUntilTimer;
                        delete audio.playUntilHandler;
                        delete audio.playUntilRateHandler;
                    }

                    // Create handler for monitoring playback
                    audio.playUntilHandler = function() {
                        if (audio.currentTime >= endTime) {
                            audio.pause();
                            // Clean up
                            clearTimeout(audio.playUntilTimer);
                            audio.removeEventListener('timeupdate', audio.playUntilHandler);
                            audio.removeEventListener('ratechange', audio.playUntilRateHandler);
                            delete audio.playUntilTimer;
                            delete audio.playUntilHandler;
                            delete audio.playUntilRateHandler;
                        }
                    };

                    // Handler for rate changes during playUntil
                    audio.playUntilRateHandler = function() {
                        // Clear existing timer
                        if (audio.playUntilTimer) {
                            clearTimeout(audio.playUntilTimer);
                        }

                        // Recalculate timeout based on new rate
                        var remainingTime = endTime - audio.currentTime;
                        var playbackRate = audio.playbackRate || 1;
                        var realTimeRemaining = (remainingTime / playbackRate) * 1000 + 500; // Add 500ms buffer

                        audio.playUntilTimer = setTimeout(function() {
                            if (!audio.paused) {
                                audio.pause();
                            }
                            audio.removeEventListener('timeupdate', audio.playUntilHandler);
                            audio.removeEventListener('ratechange', audio.playUntilRateHandler);
                            delete audio.playUntilTimer;
                            delete audio.playUntilHandler;
                            delete audio.playUntilRateHandler;
                        }, realTimeRemaining);
                    };

                    // Set up the playback
                    var startPlayback = function() {
                        audio.currentTime = startTime;
                        audio.addEventListener('timeupdate', audio.playUntilHandler);
                        audio.addEventListener('ratechange', audio.playUntilRateHandler);
                        audio.play();

                        // Calculate initial timeout accounting for current playback rate
                        var playbackRate = audio.playbackRate || 1;
                        var duration = ((endTime - startTime) / playbackRate) * 1000 + 500; // Add 500ms buffer
                        audio.playUntilTimer = setTimeout(function() {
                            if (!audio.paused) {
                                audio.pause();
                            }
                            audio.removeEventListener('timeupdate', audio.playUntilHandler);
                            audio.removeEventListener('ratechange', audio.playUntilRateHandler);
                            delete audio.playUntilTimer;
                            delete audio.playUntilHandler;
                            delete audio.playUntilRateHandler;
                        }, duration);
                    };

                    // Start playback when ready
                    if (audio.readyState === 0) {
                        audio.addEventListener('canplay', startPlayback, { once: true });
                    } else {
                        startPlayback();
                    }
                }
            });
        },

        // NEW: playBetween method - alias for playUntil for better naming
        playBetween : function(startTime, endTime) {
            return this.panzer('playUntil', startTime, endTime);
        },

        // NEW: stopPlayUntil method - stops any active playUntil operation
        stopPlayUntil : function() {
            if (this.length === 0) {
                var $allPlayers = $('.panzer');
                if ($allPlayers.length === 1) {
                    return $allPlayers.panzer('stopPlayUntil');
                }
                return this;
            }

            return this.each(function() {
                var $this = $(this), data = $this.data('panzer');

                // Get data same way as other methods
                if (!data || !data.audio) {
                    var $player = $this.next('.panzer');
                    if ($player.length) {
                        data = $player.data('panzer');
                    } else if ($this.hasClass('panzer')) {
                        data = $this.data('panzer');
                    }
                }

                if (data && data.audio) {
                    var audio = data.audio;
                    if (audio.playUntilTimer) {
                        clearTimeout(audio.playUntilTimer);
                        audio.removeEventListener('timeupdate', audio.playUntilHandler);
                        audio.removeEventListener('ratechange', audio.playUntilRateHandler);
                        delete audio.playUntilTimer;
                        delete audio.playUntilHandler;
                        delete audio.playUntilRateHandler;
                    }
                }
            });
        },

        destroy : function( ) {
            return this.each(function() {
                var $this = $(this), data = $this.data('panzer');
                if ( data ) {
                    if (iOS) {
                        $this.removeAttr("style");
                    } else {
                        if (data.loc) data.loc.after($this);
                    }
                    data.player.remove();
                    $this.removeData('panzer').removeAttr('style');
                }
            })
        }
    };

    $.fn.panzer = function( method ) {
        if ( methods[method] ) {
            return methods[method].apply( this, Array.prototype.slice.call( arguments, 1 ));
        } else if ( typeof method === 'object' || ! method ) {
            return methods.init.apply( this, arguments );
        } else {
            $.error( 'Method ' +  method + ' does not exist on jQuery.panzer' );
        }
    };

})(jQuery);
